import type { FC } from 'react';

import UpDown from '@crehana/icons/fill/UpDown';

import { SortWrapper } from './Sorter.styles';
import type { SorterProps } from './types';

const Sorter: FC<React.PropsWithChildren<SorterProps>> = ({
  className,
  isDark = false,
  isAsc,
  isDesc,
  label,
  onClick,
}) => {
  const headerColor = `text-${isDark ? 'white' : 'base-light'}`;

  return (
    <SortWrapper
      asc={isAsc}
      className={`${headerColor} ${className}`}
      desc={isDesc}
      isDark={isDark}
      onClick={onClick}
    >
      {label}
      <UpDown size={24} />
    </SortWrapper>
  );
};

export default Sorter;
